// extracted by mini-css-extract-plugin
export var chevron = "_j5-3";
export var chevronRotated = "_j5-4";
export var image = "_j5-1";
export var imageContainer = "_j5-0";
export var shippingAddress = "_j5-2";